import React from "react";
import { Mail } from "lucide-react";
import { usePublicConfig } from "../lib/usePublicConfig";

export default function ContactCard() {
    const cfg = usePublicConfig();
    return (
        <div className="ccs-card" data-testid="contact-card">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <div className="h-11 w-11 rounded-full bg-[#1E3A8A] text-white flex items-center justify-center flex-shrink-0">
                    <Mail className="h-5 w-5" />
                </div>
                <div className="flex-1">
                    <h3 className="font-heading font-semibold text-lg text-[#0F172A]">Need help or spotted an issue?</h3>
                    <p className="text-sm text-slate-600 mt-1">
                        Email us at{" "}
                        <a href={`mailto:${cfg.support_email}`} className="text-[#1E3A8A] underline font-medium" data-testid="contact-card-email">
                            {cfg.support_email}
                        </a>{" "}
                        — we read every message.
                    </p>
                </div>
            </div>
        </div>
    );
}
